import React from "react";
import {ToggleSwitchStyle} from "components/molecules/Switch/Switch.styles";

const Switch = ({value, label, switchFirst, successSwitch, className, ...props}) => {
    return (
        <>
            <ToggleSwitchStyle $switchFirst={switchFirst} $successSwitch={successSwitch} className="switch-wrap">
                {label && (
                    <label className="checkbox-label-title" htmlFor={label}>
                        {label}
                    </label>
                )}

                <input
                    type="checkbox"
                    checked={value}
                    // name={label}
                    onChange={({target: {checked}}) => {
                        props.onChange({
                            target: {value: checked},
                        });
                    }}
                    id={label}
                />
                <label className="switch" htmlFor={label}></label>
            </ToggleSwitchStyle>
        </>
    );
};

export default Switch;
